module.exports = __webpack_public_path__ + "static/media/24.53ede69c.png";